// extracted by mini-css-extract-plugin
module.exports = {"page":"AuthPage_page__WYb41","wrapper":"AuthPage_wrapper__1OQlD"};